export enum CurrencyCodeEnum {
    Euro = "EUR",
    Pound = "GBP",
    SwissFranc = "CHF",
}
